import CONSTANTS from "core/constants";
import { getCountryCode } from "helpers/getCountryCode";

type GetMeetingUrlProps = {
  slotId: number;
  vonageVideoFilterEnabled?: boolean;
};

export function getMeetingUrl({
  slotId,
  vonageVideoFilterEnabled = false,
}: GetMeetingUrlProps): string | undefined {
  const queryParams = new URLSearchParams();
  const countryCode = getCountryCode();

  const baseUrl = CONSTANTS.VIDEO_STREAM_2.PATH;
  queryParams.append("country", `${countryCode}`);
  queryParams.append("slotId", `${slotId}`);
  if (vonageVideoFilterEnabled) {
    queryParams.append("videoFilterEnabled", "true");
  }

  if (!baseUrl) return undefined;

  const queryString = queryParams.toString();

  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}
